import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ptBR from "../locales/pt-BR.json";
import esES from "../locales/es-ES.json";

const DEFAULT_LANGUAGE = "pt-BR";

const getStoredLanguage = (): string => {
  try {
    const stored = localStorage.getItem("triade-portal-language");
    return stored && ["pt-BR", "es-ES"].includes(stored)
      ? stored
      : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

i18n.use(initReactI18next).init({
  lng: getStoredLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: "common",
  ns: ["common", "navigation", "language", "forms", "pages"],
  resources: {
    "pt-BR": {
      common: ptBR.common,
      navigation: ptBR.navigation,
      language: ptBR.language,
      forms: ptBR.forms,
      pages: ptBR.pages,
    },
    "es-ES": {
      common: esES.common,
      navigation: esES.navigation,
      language: esES.language,
      forms: esES.forms,
      pages: esES.pages,
    },
  },

  interpolation: {
    escapeValue: false,
  },

  debug: process.env.NODE_ENV === "development",

  detection: {
    order: [],
    caches: [],
  },

  load: "all",
  nsSeparator: ":",
  keySeparator: ".",
  pluralSeparator: "_",
  contextSeparator: "_",
});

(i18n as any).on("languageChanged", (lng: string) => {
  try {
    localStorage.setItem("triade-portal-language", lng);
  } catch (error) {
    console.warn("Erro ao salvar idioma no localStorage:", error);
  }
});

export default i18n;
